import React, { RefObject, useEffect, useState } from 'react';

import { convertNumbersToProperFormat, isANumber } from 'utils/number';

import { getTruthy } from 'utils/happyFunctions';
import { getEffectiveName } from '../SurveyEditor/UniqueQuestion/PeriodTypeSelector/DatePeriod';
import { NumberOrNull } from 'store/entity/types';

import {
  Bold,
  Header,
  ResponseCollapseItem,
  ViewList,
  TaskListWrapper,
  surveyActionButtonStyle,
  ImportExportContainer,
  Warning,
} from './styles';
import messages from './Messages';
import HoverIcon from 'components/HoverIcon';
import AnswerView from './AnswerView';
import Select from '../../../../Select';
import { IOption } from '../../../../Select/Select';
import Icon from '../../../../Icon/Icon';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from '../SurveyEditor/GeneralQuestion/styles';
import TasksList from '../../../../../containers/Tasks/TasksManagement/TasksList';
import { display } from '../../../../ErrorView/ErrorDialog';
import { black, stringToColour } from '../../../../../utils/style/colors';
import TitleInput from '../../../../SurveyResponses/TitleInput';
import {
  QuestionBody,
  QuestionWrapper,
} from '../../../../SurveyResponses/styles';
import { IUser, IUsers } from 'store/users/usersType';
import {
  getTimeScale,
  IAnswersView,
  IChoiceView,
  IMultipleChoiceAnswerView,
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyItemWithData,
  ISurveyResponseView,
  ISurveyView,
} from 'store/survey/surveyTypes';
import { IAssignmentView, ITasks } from 'store/tasks/tasksType';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ICompany } from 'store/companies/companiesTypes';
import { ITags } from 'store/providers/providerTypes';
import Button from '../../../../Button';
import APopover from '../../../../APopover';
import Dropzone, { DropzoneRenderArgs } from 'react-dropzone';
import { CustomIcon } from '../../../../../containers/Tasks/CompanyManagement/CompanyDocuments/styles';
import { useTranslation, withTranslation } from 'react-i18next';
import { isEditableInPeriod } from './ResponseItem';
import i18n, { getCalendarLocal } from '../../../../../i18n';
import { ListItem } from '../../../../Chart/styles';
import ActionLink from '../../../../ActionLink';
import { useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../../../store/store';
import moment from 'moment-jalaali';
import IsolatedPage from 'components/Modal/IsolatedHtml';
import { requireDocument } from 'store/providers/providerSlice';

export interface DomainFeatures {
  disableExcelExport?: boolean;
  showUserId?: boolean;
  requireLogin?: boolean;
  forceHome?: string;
  showAdminInfoOnProfile?: number;
  allowProfileSearch?: boolean;
  checkForDistance?: boolean;
  customTasksName?: string;
  allowManageChecklistToUser?: boolean;
  hideTutorials?: boolean;
}

interface IComponentProps {
  user: IUser;
  users: IUsers['map'];
  showCorrectAnswers?: boolean;
  surveyItem: ISurveyItemWithData;
  companyOwnerId?: number;
  response?: ISurveyResponseView | undefined;
  survey: ISurveyView;
  onEditResponse: (responseId: number) => (e?: React.MouseEvent) => void;
  tasks: ITasks;
  thisUser: IThisUserState;
  hasRelatedTemplate?: boolean;
  markTaskAssignment: (assignment: IAssignmentView) => Promise<any>;
  handleShowTask: (taskId: number) => any;
  canEdit: boolean;
  companyId?: number;
  onCloseResponse?: (responseId: NumberOrNull) => void;
  company?: ICompany;
  embedded?: boolean;
  tags: ITags['data'];
  domainFeatures?: DomainFeatures | undefined;
  loadingExport?: boolean;
  handleExport?: () => void;
  includeScore?: RefObject<HTMLInputElement>;
  onReject?: () => void;
  onDrop?: (files: DropzoneRenderArgs['acceptedFiles']) => void;
  importFile?: File;
  importExcel?: () => void;
  importWarningMessage?: string;
  templates?: { id: number; title: string }[];
  filteredQuestionTagId?: number[];
  onCreateTask?: (
    responseId: number,
    templateId: number,
    templateName: string
  ) => void;
  htmlUrl?: string;
  onSetHtmlUrl?: (html: string) => void;
}

const ResponseViewer: React.FunctionComponent<IComponentProps> = ({
  user,
  users,
  response,
  survey,
  onCloseResponse,
  canEdit,
  onEditResponse,
  surveyItem,
  hasRelatedTemplate,
  tasks,
  companyId,
  thisUser,
  companyOwnerId,
  markTaskAssignment,
  handleShowTask,
  tags,
  company,
  embedded,
  showCorrectAnswers,
  domainFeatures,
  loadingExport,
  handleExport,
  includeScore,
  onReject,
  onDrop,
  importFile,
  importExcel,
  importWarningMessage,
  templates,
  onCreateTask,
  filteredQuestionTagId,
  htmlUrl,
  onSetHtmlUrl,
}) => {
  const { t } = useTranslation('survey');
  const providers = useSelector((store: RootState) => store.providers);
  const local =
    providers.map?.[surveyItem.data.providerId].data?.surveyOwnerProperties
      .localId || getCalendarLocal();
  const [showTaskPopover, setShowTaskPopover] = useState(false);
  // const [htmlUrl, setHtmlUrl] = useState<string>('');
  const handleClickOnTask = (taskId: number) => {
    handleShowTask(taskId);
    // const url = `/t/${companyId!}/task/editor/${taskId}/info`;
    // window.open(url);
  };

  const handleUpdateAssignmentTask = (assignment: IAssignmentView) => {
    markTaskAssignment(assignment).catch((err) => {
      display(err);
    });
  };

  const handleShowTaskPopover = () => {
    setShowTaskPopover((prevState) => !prevState);
  };

  const getMultipleChoiceValue = (
    question: IMultipleChoiceQuestionView,
    answer: any
  ): { title: string; maxPosition?: number; currentPosition?: number } => {
    let result: string | undefined = undefined;
    let maxPosition = undefined;
    let currentPosition = undefined;
    if (!answer) return { title: '' };
    if (!question.useTags) {
      (answer.values?.size
        ? answer.values.valueSeq()
        : answer.value
          ? [answer.value]
          : []
      ).forEach((value: string) => {
        const choiceIndex = question.choiceList.findIndex(
          (item: IChoiceView) => item.value === value
        );
        result =
          (result ?? '') +
          (result ? ', ' : '') +
          (question.choiceList[choiceIndex]?.text ?? '');
        currentPosition = choiceIndex;
        maxPosition = question.choiceList.length - 1;
      });
    } else {
      answer.selected.forEach((tagId: number) => {
        result =
          (result ?? '') + (result ? ', ' : '') + (tags[tagId].text ?? '');
        maxPosition = (question.tagChoices?.length ?? 0) - 1;
        currentPosition = [...(question.tagChoices ?? [])]
          ?.sort((a, b) => {
            if (tags[a].order && tags[b].order)
              return tags[a]!.order! - tags[b]!.order!;

            return 0;
          })
          .indexOf(tagId);
      });
    }
    return {
      title: result || '',
      maxPosition,
      currentPosition,
    };
  };
  const [changeLogIndex, setChangeLogIndex] = useState(-1);

  const showResponseAsHtml = survey.fields.find(
    (it) => it.name === 'conf_htmlResponseDocumentUrl'
  );

  useEffect(() => {
    if (showResponseAsHtml) {
      const quillId = (showResponseAsHtml.value || '').split('/direct/')[1];
      if (quillId) {
        appDispatch(requireDocument({ documentId: Number(quillId) })).then(
          (res: any) => {
            if (res?.item?.document?.url)
              onSetHtmlUrl?.(res?.item?.document?.url);
          }
        );
      }
    }
  }, [survey]);

  useEffect(() => {
    if (htmlUrl) {
      let params: string = '';
      response?.surveyAnswerList?.map((ans: IAnswersView) => {
        const question = questions![ans.questionId];
        const paramKey = question?.fields?.find(
          (f: any) => f.name === 'conf_keyAsParamsOfResponse'
        );
        if (paramKey) {
          params += `${paramKey.value}=${ans?.value ?? (ans as any)?.selected?.join(',') ?? (ans as any)?.values?.join(',')}&`;
        }
      });

      if (params && htmlUrl) {
        const url = new URL(htmlUrl);
        url.search = params;
        onSetHtmlUrl?.(url.toString());
      }
    }
  }, [response]);

  if (!response) {
    return (
      <ViewList embedded={embedded} hiddenIfSmall={true}>
        <ImportExportContainer>
          {surveyItem.data.changeDataToken && (
            <APopover
              arrow
              curveBorder
              placement="bottom-start"
              trigger="click"
              target={
                <Button
                  color="black-outline"
                  style={{
                    ...surveyActionButtonStyle,
                    borderRadius: '0.5rem',
                    display:
                      domainFeatures && domainFeatures.disableExcelExport
                        ? 'none'
                        : undefined,
                  }}
                  loading={loadingExport}
                >
                  <Icon className="" type="upload" />
                  {t('importExcel')}
                </Button>
              }
            >
              <div>
                <h6
                  style={{ display: 'inline-block' }}
                  className="no-margin green-text text-darken-2"
                >
                  {t('importResponsesFromExcel')}
                </h6>
                <QuestionHintBox>
                  <HintIcon type="info" />
                  <HintText>
                    <div>{t('importNote')}</div>
                    <div>{t('importNoteMatchColumnName')}</div>
                    <div>{t('importNoteIndicator')}</div>
                    <div>{t('importNoteMultiChoice')}</div>
                    <div>{t('importNoteProblem')}</div>
                    <div>{t('importNoteNoProblem')}</div>
                    <div>{t('importNoteExportNotCompatible')}</div>
                  </HintText>
                </QuestionHintBox>
                <Dropzone
                  style={{
                    width: '100%',
                    height: '100px',
                    border: '1px solid lightGray',
                    borderRadius: '0.5rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  multiple={false}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onDropRejected={onReject}
                  onDropAccepted={onDrop}
                >
                  {/* @ts-expect-error JSX error */}
                  {() => (
                    <div>
                      <div>{importFile?.name ?? t('selectFile')}</div>
                      <CustomIcon type={importFile ? 'check' : 'plus'} />
                    </div>
                  )}
                </Dropzone>
                <Button
                  onClick={importExcel}
                  loading={loadingExport}
                  disabled={!importFile}
                  color="green"
                  style={{ margin: '0.5rem 0' }}
                >
                  {t('import')}
                </Button>
                {importWarningMessage && (
                  <Warning>{importWarningMessage}</Warning>
                )}
              </div>
            </APopover>
          )}
          <APopover
            arrow
            curveBorder
            placement="bottom-start"
            trigger="click"
            target={
              <Button
                color="black-outline"
                style={{
                  ...surveyActionButtonStyle,
                  display:
                    domainFeatures && domainFeatures.disableExcelExport
                      ? 'none'
                      : undefined,
                  padding: '0.5rem 1.5rem',
                  margin: '1rem',
                  borderRadius: '0.5rem',
                }}
                loading={loadingExport}
              >
                <Icon className="" type="download" />
                <div>{t('exportExcel')}</div>
              </Button>
            }
          >
            <div>
              <h6
                style={{ display: 'inline-block' }}
                className="no-margin green-text text-darken-2"
              >
                {t('downloadResponses')}
              </h6>
              <p className="switch">
                <label>
                  <input
                    name="includeScore"
                    id="includeScore"
                    type="checkbox"
                    ref={includeScore}
                  />
                  <span
                    className="lever"
                    style={{
                      marginInlineStart: '0',
                      marginInlineEnd: '10px',
                    }}
                  />
                </label>
                {t('includeScore')}
              </p>
              <Button
                onClick={handleExport}
                loading={loadingExport}
                color="green"
              >
                {t('download')}
              </Button>
            </div>
          </APopover>
        </ImportExportContainer>
        <QuestionHintBox
          style={{
            width: 'fit-content',
            margin: 'auto',
            marginTop: '7.5%',
          }}
        >
          <HintIcon type="info" />
          <HintText>
            <span>{t('emptyPlaceHolder')}</span>
          </HintText>
        </QuestionHintBox>
      </ViewList>
    );
  }
  const filteredTasks =
    hasRelatedTemplate && response
      ? Object.values(tasks.data).filter(
          (task) =>
            task.relatedProviderItems?.find(
              (it) => it.id === surveyItem.data.id
            ) &&
            task.fields.find(
              (f: any) =>
                (f.type === 'responseLink' || f.type === 'analyseLink') &&
                f.value === response.id!.toString()
            )
        )
      : undefined;

  const version = survey.versions[response.surveyVersion];
  const periodType = getTimeScale(version.periodType);

  const questions = version!.questionMap;

  function getOption(index: number) {
    let stageQuestionAnswerInfo:
      | { title: string; maxPosition?: number; currentPosition?: number }
      | undefined = undefined;
    if (version.stageQuestion) {
      const stageQuestionAnswer =
        index === -1
          ? response!.surveyAnswerList.find(
              (answer: any) => answer.questionId === version.stageQuestion
            )
          : response!.changeLog![index].answerList.find(
              (answer: any) => answer.questionId === version.stageQuestion
            );
      const stageQuestion = questions![
        version.stageQuestion
      ] as IMultipleChoiceQuestionView;
      stageQuestionAnswerInfo = getMultipleChoiceValue(
        stageQuestion,
        stageQuestionAnswer
      );
    }
    const res = {
      value: index,
      label:
        index === -1
          ? messages.versionTitle(
              new Date(response!.updateDate!),
              users[response!.lastUpdateBy!]?.name,
              stageQuestionAnswerInfo?.title
            )
          : messages.versionTitle(
              new Date(response!.changeLog![index].updateDate!),
              users[response!.changeLog![index].userId!]?.name,
              stageQuestionAnswerInfo?.title
            ),
      currentPosition: stageQuestionAnswerInfo?.currentPosition,
      maxPosition: stageQuestionAnswerInfo?.maxPosition,
    };
    return res;
  }

  let relatedUser = undefined;
  const instanceIsUser = surveyItem.data.instanceType === 'User';
  if (instanceIsUser) relatedUser = users[response.instance!];
  let toViewChangeLog = changeLogIndex;
  const changeLog = response.changeLog;
  if (!changeLog || toViewChangeLog >= changeLog.length) toViewChangeLog = -1;
  const surveyAnswerList =
    toViewChangeLog === -1
      ? response.surveyAnswerList
      : response.changeLog![toViewChangeLog].answerList;
  const hasChangeLog = response.changeLog && response.changeLog.length > 0;
  const printTemplate = survey.fields.find(
    (it) => it.name === 'conf_printTemplate'
  );

  const printResponse = () => {
    const props = {};
    Object.values(surveyAnswerList).forEach((answer) => {
      const questionId = answer.questionId;
      const questionData = questions![questionId];
      if (questionData.type === 'text') {
        let textValue = answer.value;
        if (questionData.inputType === 'date')
          textValue = moment(Number(textValue)).format('jYYYY/jMM/jDD');
        props[questionId] = {
          type: 'text',
          value: textValue,
        };
        props[questionData.title] = {
          type: 'text',
          value: textValue,
        };
      } else if (questionData.type === 'multipleChoice') {
        let value = '';
        if (questionData.useTags) {
          (answer as IMultipleChoiceAnswerView).selected.forEach(
            (tagId: number) => {
              const choice = tags[tagId].text;
              if (choice) value = (value.length ? '، ' : '') + choice;
            }
          );
        } else {
          ((answer as IMultipleChoiceAnswerView).values?.length
            ? (answer as IMultipleChoiceAnswerView).values
            : answer.value
              ? [answer.value]
              : []
          ).forEach((v: string) => {
            const choice = questionData.choiceList.find(
              (item: IChoiceView) => item.value === v
            );
            if (choice) value = (value.length ? '، ' : '') + choice.text;
          });
        }
        props[questionId] = {
          type: 'multiChoice',
          value: value,
        };
        props[questionData.title] = {
          type: 'multiChoice',
          value: value,
        };
      }
    });
    props['responseId'] = response.id;
    props['submitDate'] = response.submitDate;
    props['surveyId'] = survey.id;
    props['surveyName'] = survey.name;
    props['itemId'] = surveyItem.data.id;
    props['printTemplate'] = printTemplate?.value;
    props['sender.id'] = response.userId;
    if (response.userId && company) {
      props['sender.signature'] =
        company.members[response.userId]?.signature?.url;
    }
    if (survey.trackResponseChanges && survey.stageQuestion) {
      response.changeLog!.forEach((e: any) => {
        const stageAnswer = e.answerList.find(
          (a: any) => a.questionId === survey.stageQuestion
        );
        const stageAnswerText =
          stageAnswer.value || stageAnswer.selected.get(0);
        const user = e.userId;
        const userSignature = company?.members[user]?.signature?.url;
        const updateDate = e.updateDate;
        if (!props['stage.' + stageAnswerText + '.user']) {
          props['stage.' + stageAnswerText + '.user'] = users[user].name;
          props['stage.' + stageAnswerText + '.updateDate'] = updateDate;
          props['stage.' + stageAnswerText + '.signature'] = userSignature;
        }
      });

      const stageAnswer = response.surveyAnswerList.find(
        (a: any) => a.questionId === survey.stageQuestion
      );
      // @ts-expect-error it's ok
      const stageAnswerText = stageAnswer!.value || stageAnswer!.selected![0];
      const user = response.lastUpdateBy!;
      const userSignature = company?.members[user]?.signature?.url;
      const updateDate = response.updateDate;
      if (!props['stage.' + stageAnswerText + '.user']) {
        props['stage.' + stageAnswerText + '.user'] = users[user].name;
        props['stage.' + stageAnswerText + '.updateDate'] = updateDate;
        props['stage.' + stageAnswerText + '.signature'] = userSignature;
      }
    }

    const signatureQuestion = Object.values(questions || {}).find((it) =>
      it.fields?.find((it) => it.name === 'conf_useAsSignature')
    ) as IMultipleChoiceQuestionView | undefined;
    if (signatureQuestion) {
      const signatureAnswer = response.surveyAnswerList.find(
        (a: any) => a.questionId === signatureQuestion?.id
      ) as IMultipleChoiceAnswerView | undefined;
      if (signatureAnswer) {
        const answerText = signatureQuestion.choiceList.find(
          (it) =>
            it.value === signatureAnswer?.value ||
            signatureAnswer?.values.includes(it.value)
        )?.text;
        const user = Object.values(users).find((it) => it.name === answerText);
        if (user)
          props['signatureUrl'] = company?.members[user.id].signature?.url;
      }
    }

    localStorage.setItem('printableSurveyResponse', JSON.stringify(props));
    const win = window.open('/print/response', '_blank');
    if (win) {
      win.focus();
    }
  };

  const selectedOption = getOption(toViewChangeLog);
  return (
    <ViewList embedded={embedded}>
      {htmlUrl ? (
        <>
          <IsolatedPage src={htmlUrl} />
        </>
      ) : (
        <>
          <Header
            embedded={embedded}
            style={{
              backgroundColor: isANumber(selectedOption?.currentPosition)
                ? stringToColour(
                    'x',
                    1,
                    false,
                    'x',
                    selectedOption.currentPosition,
                    selectedOption.maxPosition
                  )
                : undefined,
              justifyContent: embedded ? 'flex-end' : undefined,
            }}
          >
            {!embedded &&
              (instanceIsUser ||
                (response.effectiveDate && periodType && (
                  <div style={{ display: 'grid' }}>
                    {instanceIsUser && (
                      <Bold>
                        <Icon type="user" style={{ margin: ' 0px 5px' }} />
                        {relatedUser
                          ? `${relatedUser.name}`
                          : `${t('unknownUser')}`}
                      </Bold>
                    )}
                    {response.effectiveDate && periodType && (
                      <Bold>
                        <Icon type="clock" style={{ margin: ' 0px 5px' }} />
                        {getEffectiveName(
                          periodType,
                          response.effectiveDate,
                          local
                        )}
                      </Bold>
                    )}
                  </div>
                )))}
            {!embedded ? (
              <Bold>
                <Icon
                  type="send"
                  style={{ marginInlineEnd: '0.5rem', marginTop: 'auto' }}
                />
                {user ? `${user.name}` : `${t('unknownUser')}`}
              </Bold>
            ) : (
              <></>
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {
                <span style={{ marginInlineStart: '1rem' }}>
                  <Select
                    round={true}
                    values={[selectedOption]}
                    options={
                      hasChangeLog
                        ? response!
                            .changeLog!.map((_: any, index: number) =>
                              getOption(index)
                            )
                            .reduce(
                              (list: IOption[], item: IOption) => {
                                list.splice(1, 0, item);
                                return list;
                              },
                              [getOption(-1)]
                            )
                        : [getOption(-1)]
                    }
                    onChangeValues={(values) => {
                      setChangeLogIndex(Number(values[0].value));
                    }}
                    allowRemove={false}
                    isRequired={true}
                  />
                </span>
              }
              {!embedded && canEdit ? (
                isEditableInPeriod(surveyItem, survey, response) && (
                  <HoverIcon
                    style={{ margin: '0 0.5rem' }}
                    type="edit-2"
                    color="white"
                    onClick={onEditResponse(response.id!)}
                  />
                )
              ) : (
                <></>
              )}

              {printTemplate ? (
                <HoverIcon
                  style={{ margin: '0 0.5rem' }}
                  type="printer"
                  color="white"
                  onClick={printResponse}
                />
              ) : (
                <></>
              )}
              {survey.surveyType !== 'Exam' &&
              templates?.length &&
              response.id &&
              onCreateTask ? (
                <APopover
                  arrow={true}
                  curveBorder={true}
                  trigger="click"
                  show={showTaskPopover}
                  onShowChange={handleShowTaskPopover}
                  target={
                    <ActionLink color="green">
                      <HoverIcon type={'clipboard'} color="white" />
                    </ActionLink>
                  }
                >
                  <div>
                    {templates.map((it) => (
                      <ListItem
                        key={it.id}
                        onClick={() => {
                          setShowTaskPopover(false);
                          onCreateTask(response.id!, it.id, it.title);
                        }}
                      >
                        <Icon type="plus" color={`${black}`} />
                        <span>
                          {
                            i18n.t('addTask', {
                              name: it.title,
                              ns: 'survey',
                            }) as string
                          }
                        </span>
                      </ListItem>
                    ))}
                  </div>
                </APopover>
              ) : (
                <></>
              )}
              {onCloseResponse ? (
                <HoverIcon
                  type="x"
                  color="white"
                  onClick={() => {
                    onCloseResponse(null);
                  }}
                  style={{ marginInlineStart: '0.75rem' }}
                />
              ) : (
                <></>
              )}
            </div>
          </Header>

          {response.title ? (
            <p style={{ margin: '15px' }}>
              {t('title')}: <b>{response.title}</b>
            </p>
          ) : (
            <></>
          )}
          <ResponseCollapseItem>
            {companyId && hasRelatedTemplate && !!filteredTasks!.length && (
              <TaskListWrapper>
                <TasksList
                  tasks={filteredTasks as any}
                  loading={false}
                  thisUser={thisUser}
                  companyId={companyId}
                  projectId={undefined}
                  onUpdateTask={() => {
                    /*do nothing*/
                  }}
                  requireTasks={() => {
                    /*do nothing*/ return Promise.resolve();
                  }}
                  showProgress={false}
                  showWeight={false}
                  taskSelected={false}
                  companyOwnerId={companyOwnerId!}
                  unfilteredTasks={tasks as any}
                  allTasksFetched={true}
                  handleClickOnTask={handleClickOnTask}
                  onUpdateAssignment={handleUpdateAssignmentTask}
                  templateSelected={false}
                  widthMultiplier={window.innerWidth < 600 ? 1 : 0.5}
                />
              </TaskListWrapper>
            )}
            {surveyAnswerList &&
              Object.values(surveyAnswerList)
                .sort((a, b) => {
                  const aQuestionOrder = questions![a.questionId]?.order ?? 0;
                  const bQuestionOrder = questions![b.questionId]?.order ?? 0;
                  return aQuestionOrder - bQuestionOrder;
                })
                .map((answer: IAnswersView) => {
                  const questionId = answer.questionId;
                  const answerScore = getTruthy(
                    answer.score,
                    t('withoutScore')
                  );
                  let questionData: null | IQuestionsView =
                    questions?.[questionId] ?? null;

                  if ((filteredQuestionTagId?.length || 0) > 0) {
                    const hasFilteredTag = filteredQuestionTagId!.every(
                      (fid: number) =>
                        questionData?.tags?.some(
                          (tag) => Number(tag.id) === fid
                        )
                    );
                    if (!hasFilteredTag) questionData = null;
                  }
                  if (
                    (questionData as IMultipleChoiceQuestionView | null)
                      ?.readFromItemTag &&
                    surveyItem?.data?.upstreamItemId
                  )
                    return <React.Fragment key={questionData?.id} />;
                  return questionData ? (
                    <QuestionWrapper key={questionData.id} disabled={false}>
                      <TitleInput
                        fields={questionData.fields || []}
                        hint={questionData.hint}
                        required={questionData.answerRequired}
                        title={questionData.title}
                        tags={questionData.tags}
                        allTags={tags}
                        badge={
                          typeof answerScore === 'number'
                            ? messages.responseScore(
                                convertNumbersToProperFormat(answerScore)
                              )
                            : undefined
                        }
                        indexNumber={questionData.indexOrder}
                        survey={survey}
                      />
                      <QuestionBody>
                        <AnswerView
                          survey={survey}
                          surveyItem={surveyItem}
                          answer={answer}
                          question={questionData}
                          isExam={survey.surveyType === 'Exam'}
                          showCorrectAnswers={showCorrectAnswers}
                          providerId={surveyItem.data.providerId}
                        />
                      </QuestionBody>
                    </QuestionWrapper>
                  ) : (
                    <> </>
                  );
                  // return (
                  //   <Collapsible
                  //     key={answer.get('questionId')}
                  //     defaultOpen={false}
                  //     headerBackgroundColor="#f2f5f7"
                  //     iconName={getQuestionIcon[questionData.type]}
                  //     customHeaderStyle={responseTitleStyle}
                  //     nested={embedded}
                  //     header={
                  //       <React.Fragment>
                  //         <span style={responseTitleStyle}>
                  //           {questionData.title}
                  //         </span>
                  //         {typeof answerScore === 'number' && (
                  //           <Badge color="green" style={responseBadgeStyle}>
                  //             {`${t("responseScore(
                  //               convertNumbersToProperFormat(
                  //                 roundToDynamicFloating(answerScore)
                  //               )
                  //             )}
                  //           `}
                  //           </Badge>
                  //         )}
                  //       </React.Fragment>
                  //     }
                  //   >
                  //     <AnswerView answer={answer} question={questionData} />
                  //   </Collapsible>
                  // );
                })}
          </ResponseCollapseItem>
        </>
      )}
    </ViewList>
  );
};

export default React.memo(withTranslation('taskManager')(ResponseViewer));
